import Vue from 'vue'
import clickOutside from './v-click-outside'
import { VTooltip } from 'v-tooltip'

Vue.directive('click-outside', clickOutside)
Vue.directive('tooltip', VTooltip)
